
<div class="text-center">
    <div #signinGoogleBtn class="text-center"></div>
  </div>


<a routerLink="/communication/create" *ngIf="userLoggedIn">Mon compte</a>